module.exports = __webpack_public_path__ + "img/heroIconGift.96cd0066.svg";